import { CrudTable, StatusBadge } from "@/components/shared";

export default function Referrals() {
  const columns = [
    { key: "date", label: "Date", render: (r) => r.date?.slice(0, 10) },
    { key: "person", label: "By" },
    { key: "branch", label: "Branch" },
    { key: "referred_by", label: "Referred By" },
    { key: "referred_patient", label: "Referred Patient" },
    { key: "status", label: "Status", render: (r) => <StatusBadge value={r.status} /> },
    { key: "remark", label: "Remark" },
  ];
  const fields = [
    { key: "date", label: "Date", type: "date" },
    { key: "branch", label: "Branch", type: "select", optionsKey: "branches" },
    { key: "referred_by", label: "Referred By (existing patient)", type: "text" },
    { key: "referred_patient", label: "Referred Patient (new)", type: "text" },
    { key: "status", label: "Status", type: "select", options: ["Pending", "Visited", "Converted"] },
    { key: "remark", label: "Remark", type: "textarea", full: true },
  ];
  return (
    <CrudTable testid="referrals" endpoint="referrals" dateField="date"
      title="Referrals"
      subtitle="Kis patient ne kisko refer kiya aur uska status — visited ya converted."
      columns={columns} fields={fields} defaults={{ status: "Pending" }} />
  );
}
